import { render } from "./HomeNewsManagement.vue?vue&type=template&id=92bd9994&scoped=true"
import script from "./HomeNewsManagement.vue?vue&type=script&lang=js"
export * from "./HomeNewsManagement.vue?vue&type=script&lang=js"

import "./HomeNewsManagement.vue?vue&type=style&index=0&id=92bd9994&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92bd9994"]])

export default __exports__